import i18n from '@/utils/i18n';
import { useBusinessOrganizationPricingConfig } from '@sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useEffect } from 'react';
import { useExperienceToasts } from '@experiences/hooks/use-experience-toasts';
import { usePricingEditsStore } from '@/experiences/sales-portal/domain/pricing/blocs/stores/pricing-edits-store';
import { useShallow } from 'zustand/shallow';

export const usePricingEditsTimezoneSync = () => {
  const { showToast } = useExperienceToasts();
  const {
    currencyCode,
    timezone,
    loading: timezoneLoading,
  } = useBusinessOrganizationPricingConfig();

  const { expiredEditsCount, revertAllEdits, setSupplierTimezone } =
    usePricingEditsStore(
      useShallow((state) => ({
        expiredEditsCount: state.expiredEditsCount,
        revertAllEdits: state.revertAllEdits,
        setSupplierTimezone: state.setSupplierTimezone,
      })),
    );

  useEffect(() => {
    if (expiredEditsCount > 0) {
      showToast({
        description: i18n.t('pricing.edits_expired_alert.message'),
        title:
          expiredEditsCount === 1
            ? i18n.t('pricing.edits_expired_alert.title.singular')
            : i18n.t('pricing.edits_expired_alert.title.plural', {
                count: expiredEditsCount,
              }),
        variant: 'warning',
      });
      revertAllEdits();
    }
    // run the effect only when there are expired edits
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiredEditsCount]);

  useEffect(() => {
    if (timezone) {
      setSupplierTimezone(timezone);
    }
  }, [timezone, setSupplierTimezone]);

  return { currencyCode, timezone, timezoneLoading };
};
